import cz from "./cz"
import en from "./en"

export default [
    ["en", "English", null, en],
    ["cz", "Čeština", ["cs"], cz],
]
